console.log('components');

import './components/swiper';
import './components/lang';
import './components/burger';
import './components/tabs';
